module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/6_33b3cac3c8ce5ef52315b59c9ca67ffe.png";